import { httpPostFile } from '../../../utils/api.utils';
import { FILE_ATTACHMENT_MODULES } from '../../../constants/external-constants';
import {
    resetFileAttachment
    , updateAttachFile
    , setDisableAttachBtn
} from '../../../constants/model-reducers/external/common/file-attachment.settings';

const defaultFileAttachmentState = () => ({
    files: [],
    orderAmmendFileNames: [],
    disableAttchBtn: false
});

const initialState = defaultFileAttachmentState();

export const fileAttachmentActions = {
    resetFileAttachment: () => (dispatch) => {
        let newState = defaultFileAttachmentState();
        dispatch({ type: resetFileAttachment, data: newState });
    },
    updateAttachFile: (files) => (dispatch) => {
        dispatch({ type: updateAttachFile, data: files });
    },
    uploadFile: id => async (dispatch, state) => {
        const { files } = state().fileAttachment;

        var formData = new FormData();
        if (files != null && files.length > 0) {
            for (var i = 0; i < files.length; i++) {
                formData.append("File", files[i]);
            }
        } else {
            return;
        }

        formData.append("FolderId", id);
        formData.append("FileAttachmentModule", FILE_ATTACHMENT_MODULES.orderCreation);
        dispatch({ type: setDisableAttachBtn, data: true });

        var res = await httpPostFile('common/fileAttachment', formData);

        if (res.Result) {
            dispatch({ type: setDisableAttachBtn, data: false });
        }

        return res;
    },
    saveOrderFile: (id, fileNames) => async (dispatch, state) => {
        const { files } = state().fileAttachment;
        var formData = new FormData();
        if (files != null && files.length > 0) {
            for (var i = 0; i < files.length; i++) {
                formData.append("File", files[i]);
            }
        } else {
            return;
        }
        formData.append("FolderId", id);
        formData.append("FileAttachmentModule", FILE_ATTACHMENT_MODULES.orderCreation);
        formData.append("FileNames", fileNames);
        httpPostFile('external/orderRequest/saveOrderFile', formData);
    }
};

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case resetFileAttachment:
            return {
                ...action.data
            };
        case updateAttachFile:
            return {
                ...state,
                files: action.data
            };
        case setDisableAttachBtn:
            return {
                ...state,
                disableAttchBtn: action.data
            };
        default:
            return state;
    }
};